import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import MapFilterControls from '../components/MapFilterConrtrols';
import Map from '../components/Map';
import { Row, Col, Form, FormControl } from "react-bootstrap";
import Button from 'react-crud-table/build/Button';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import '../styles/adminhome.css';
import Sidebar from "../adminside/Sidebar";
import API_URL from "../config/api";

function Home() {

    const [searchParams] = useSearchParams();
    const treeId = searchParams.get('treeId');
    const [treeData, setTreeData] = useState(null);
    const [activeSlideIndex, setActiveSlideIndex] = useState(0);
    const [slides, setSlides] = useState([]);
    const [thumbnails, setThumbnails] = useState([]);
    const [speciesList, setSpeciesList] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [date, setDate] = useState(new Date());
    const [numberOfUsers, setNumberOfUsers] = useState(0);
    const [numberOfPins, setNumberOfPins] = useState(0);
    const [speciesColorMap, setSpeciesColorMap] = useState({});

    useEffect(() => {
        fetchUserCount();
        fetchPinsCount();

    }, [treeId]);

    const fetchUserCount = async () => {

        try {

            const response = await fetch(`${API_URL}/admin/get_user_count.php`
            );

            const data = await response.json();

            setNumberOfUsers(data.total);

        } catch (err) {

            console.error(err);

        }

    };

    const fetchPinsCount = async () => {
        try {
            let url = `${API_URL}/admin/get_pin_count.php`;

            if (treeId) {
                url += `?speciesid=${encodeURIComponent(treeId)}`;
            }

            console.log("Fetching pin count from:", url);

            const response = await fetch(url);

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const data = await response.json();

            console.log("PIN COUNT RESPONSE:", data);

            setNumberOfPins(Number(data.total) || 0);

        } catch (err) {
            console.error("Error fetching pin count:", err);
            setNumberOfPins(0);
        }
    };

    const navigate = useNavigate();

    useEffect(() => {
        const fetchTreeData = async () => {
            if (!treeId) return;

            try {

                const response = await fetch(`${API_URL}/tree/get_tree.php?speciesid=${treeId}`
                );
                const data = await response.json();
                setTreeData(data);
                setThumbnails(data.imgurl || []);
                setSlides([{}]);
            } catch (err) {
                console.error(err);
            }
        };

        const fetchSpeciesList = async () => {
            try {
                const response = await fetch(`${API_URL}/tree/get_species.php`
                );
                const data = await response.json();
                setSpeciesList(data);
            } catch (err) {
                console.error(err);
            }
        };

        fetchTreeData();
        fetchSpeciesList();
    }, [treeId]);

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredSpecies = speciesList.filter(species =>
        species.name.toLowerCase().startsWith(searchQuery.toLowerCase())
    );

    useEffect(() => {
        const fetchSpeciesColorMap = async () => {
            try {
                const response = await fetch(`${API_URL}/tree/get_species_color.php`
                );
                const data = await response.json();
                const colorMap = {};
                data.forEach(item => {
                    colorMap[item.speciesid] = item.color;
                });
                setSpeciesColorMap(colorMap);
            } catch (err) {
                console.error(err);
            }
        };

        fetchSpeciesColorMap();

    }, []);

    return (

    <div className="App">

    <Sidebar />

    <section className="tree-section">
                    <br />
                    <br />
                    <Row>
                        <Col md={10}>
                            {/* Map Section */}
                            <div className='mapContainerAdminMap'>
                                <Map />
                            </div>
                        </Col>
                        <Col md={2}><br /><br /><br /><br />
                            <div>
                                <Row>
                                    <Col md={1}></Col>
                                    <Col md={10}>
                                        <Link
                                            to="/Home"
                                            className="submitbtnadminmap"
                                            style={{ textDecoration: "none", color: "black" }}
                                        >
                                            View All Pins
                                        </Link>
                                    </Col>
                                    <Col md={1}></Col>
                                </Row>
                                <br />
                                <Row>
                                </Row>
                                <br />
                                <Form>
                                    <FormControl
                                        type="text"
                                        placeholder="Search species"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                </Form>
                                <Row style={{ padding: '5%', textAlign: 'center', justifyContent: 'center', margin: '5%', maxHeight: '500px', overflowY: 'auto', overflowX: 'hidden' }}>
                                    {filteredSpecies.map(species => (
                                        <Link key={species.speciesid} to={`/Home?treeId=${species.speciesid}`} className='ahrefadminmap' style={{ backgroundColor: speciesColorMap[species.speciesid] }}>{species.name}</Link>
                                    ))}
                                </Row>

                            </div>
                        </Col>
                        <Row style={{ marginTop: '-8%' }}>
                            <div className="dashboard-footer">
                                <div className="dashboard-cards">
                                    {/* <div className='dash-cards'>
                                        <img src='https://relaxed-joliot-41cdfa.netlify.app/.netlify/functions/counter?id=1399' style={{ width: '150px' }}></img>
                                    </div> */}
                                    <div className="dash-cards">
                                        <h3>Users</h3>
                                        <h1>{numberOfUsers}</h1>
                                    </div>
                                    <div className="dash-cards">
                                        <h3>Trees</h3>
                                        <h1>{numberOfPins}</h1>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Row>

                </section>
            </div>
    );
}

export default Home;
